module.exports = __webpack_public_path__ + "img/avatar-4.da58328b.jpg";